import { Link } from "react-router-dom";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";

export default function PaymentCancel() {
  return (
    <main className="min-h-screen bg-paper" data-testid="payment-cancel-page">
      <Nav />
      <div className="mx-auto max-w-2xl px-5 md:px-8 pt-36 md:pt-44 pb-28">
        <h1 className="font-serif text-4xl md:text-5xl tracking-tight text-ink" data-testid="cancel-heading">
          No charge has been made.
        </h1>
        <p className="mt-6 text-base md:text-lg text-ink/65 leading-relaxed">
          The payment was cancelled before it completed, so nothing has been
          taken and no booking is confirmed. If you hesitated because something
          wasn’t clear, that’s understandable — whenever you’re ready, the
          First Walk is there.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <Link
            to="/book"
            data-testid="cancel-retry-button"
            className="inline-flex items-center justify-center rounded-full bg-ink text-paper px-8 py-4 text-base font-semibold tracking-wide transition-colors duration-300 hover:bg-pine"
          >
            Try booking again
          </Link>
          <Link
            to="/"
            data-testid="cancel-home-link"
            className="inline-flex items-center justify-center rounded-full border border-ink/25 text-ink px-8 py-4 text-base font-semibold tracking-wide transition-colors duration-300 hover:bg-ink/5"
          >
            Back to the site
          </Link>
        </div>
      </div>
      <Footer />
    </main>
  );
}
